import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function Adherents() {
  const [adherents, setAdherents]     = useState([]);
  const [loading, setLoading]         = useState(true);
  const [selected, setSelected]       = useState(null);
  const [structures, setStructures]   = useState([]);
  const [adherentUsers, setAdherentUsers] = useState([]);
  const [allUsers, setAllUsers]       = useState([]);
  const [showForm, setShowForm]       = useState(false);
  const [showStructForm, setShowStructForm]   = useState(false);
  const [showTransfertForm, setShowTransfertForm] = useState(null); // structure à transférer
  const [editAdherent, setEditAdherent]   = useState(null);
  const [editStructure, setEditStructure] = useState(null);
  const [regions, setRegions]         = useState([]);
  const [form, setForm]               = useState({ user_id: '', npp: '', nom_commercial: '', region_ecf: '' });
  const [structForm, setStructForm]   = useState({ raison_sociale: '', siren: '', siret: '', type_structure: 'SARL', est_holding: false });
  const [transfertForm, setTransfertForm] = useState({ adherent_dest_id: '', motif: '' });
  const [msg, setMsg]                 = useState(null);
  const [saving, setSaving]           = useState(false);
  const [activeTab, setActiveTab]     = useState('structures'); // structures | users

  useEffect(() => { loadAdherents(); loadRegions(); }, []);

  const loadAdherents = async () => {
    try { const { data } = await api.get('/adherents/'); setAdherents(data); }
    catch (e) {} finally { setLoading(false); }
  };

  const loadRegions = async () => {
    try { const { data } = await api.get('/regions/'); setRegions(data); } catch (e) {}
  };

  const loadStructures = async (id) => {
    try { const { data } = await api.get(`/adherents/${id}/structures`); setStructures(data); } catch (e) {}
  };

  const loadAdherentUsers = async (id) => {
    try { const { data } = await api.get(`/adherents/${id}/users`); setAdherentUsers(data); } catch (e) {}
  };

  const loadAllUsers = async () => {
    try { const { data } = await api.get('/users/'); setAllUsers(data); } catch (e) {}
  };

  const selectAdherent = (a) => {
    setSelected(a); setActiveTab('structures');
    loadStructures(a.id); loadAdherentUsers(a.id);
    setEditAdherent(null); setEditStructure(null);
  };

  const handleCreateAdherent = async (e) => {
    e.preventDefault();
    if (!form.region_ecf) { setMsg({ type: 'error', text: 'La région ECF est obligatoire' }); return; }
    setSaving(true);
    try {
      await api.post('/adherents/', { ...form, user_id: form.user_id || null });
      setMsg({ type: 'success', text: 'Adhérent créé.' });
      loadAdherents();
      setTimeout(() => { setShowForm(false); setMsg(null); setForm({ user_id: '', npp: '', nom_commercial: '', region_ecf: '' }); }, 1500);
    } catch (err) {
      setMsg({ type: 'error', text: err.response?.data?.detail || 'Erreur' });
    } finally { setSaving(false); }
  };

  const handleUpdateAdherent = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put(`/adherents/${editAdherent.id}`, {
        npp: editAdherent.npp,
        nom_commercial: editAdherent.nom_commercial,
        region_ecf: editAdherent.region_ecf,
      });
      setMsg({ type: 'success', text: 'Adhérent mis à jour.' });
      loadAdherents();
      setSelected({ ...selected, ...editAdherent });
      setTimeout(() => { setEditAdherent(null); setMsg(null); }, 1500);
    } catch (err) {
      setMsg({ type: 'error', text: err.response?.data?.detail || 'Erreur' });
    } finally { setSaving(false); }
  };

  const handleCreateStructure = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/adherents/${selected.id}/structures`, structForm);
      loadStructures(selected.id);
      setShowStructForm(false);
      setStructForm({ raison_sociale: '', siren: '', siret: '', type_structure: 'SARL', est_holding: false });
    } catch (err) {}
  };

  const handleUpdateStructure = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/adherents/${selected.id}/structures/${editStructure.id}`, editStructure);
      loadStructures(selected.id);
      setEditStructure(null);
    } catch (err) {}
  };

  const handleTransfert = async (e) => {
    e.preventDefault();
    if (!transfertForm.adherent_dest_id) return;
    try {
      const { data } = await api.post('/transferts/', {
        structure_id: showTransfertForm.id,
        adherent_dest_id: transfertForm.adherent_dest_id,
        motif: transfertForm.motif,
      });
      alert(data.message);
      setShowTransfertForm(null);
      setTransfertForm({ adherent_dest_id: '', motif: '' });
      loadStructures(selected.id);
      loadAdherents();
    } catch (err) {
      alert(err.response?.data?.detail || 'Erreur lors du transfert');
    }
  };

  const handleAddUser = async (userId) => {
    try {
      await api.post(`/adherents/${selected.id}/users/${userId}`);
      loadAdherentUsers(selected.id);
    } catch (err) { alert(err.response?.data?.detail || 'Erreur'); }
  };

  const handleRemoveUser = async (userId) => {
    if (!window.confirm('Détacher cet utilisateur ?')) return;
    try {
      await api.delete(`/adherents/${selected.id}/users/${userId}`);
      loadAdherentUsers(selected.id);
    } catch (err) { alert(err.response?.data?.detail || 'Erreur'); }
  };

  const RegionSelect = ({ value, onChange, required }) => (
    <select className="form-input" value={value || ''} onChange={e => onChange(e.target.value)} required={required} style={{ margin: 0 }}>
      <option value="">— Sélectionner une région —</option>
      {regions.map(r => <option key={r.id} value={r.libelle}>RÉGION {r.numero} — {r.libelle}</option>)}
    </select>
  );

  const usersNonRattaches = allUsers.filter(u => !adherentUsers.find(au => au.user_id === u.id));

  return (
    <div>
      <div className="topbar">
        <div className="topbar-title">Adhérents</div>
        <button className="btn btn-primary" onClick={() => { setShowForm(true); setMsg(null); }}>
          + Nouvel adhérent
        </button>
      </div>
      <div className="page-content">

        {/* Modal création adhérent */}
        {showForm && (
          <div className="modal-overlay">
            <div className="modal-box">
              <div className="modal-header">
                <span className="modal-title">Nouvel adhérent</span>
                <button onClick={() => { setShowForm(false); setMsg(null); }} className="modal-close">✕</button>
              </div>
              <div className="modal-body">
                {msg && <div className={`alert alert-${msg.type}`}>{msg.text}</div>}
                <form onSubmit={handleCreateAdherent}>
                  <div className="form-group">
                    <label className="form-label">NPP <span style={{ color: 'var(--ecf-error)' }}>*</span></label>
                    <input className="form-input" value={form.npp} onChange={e => setForm({ ...form, npp: e.target.value })} required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Nom commercial <span style={{ color: 'var(--ecf-error)' }}>*</span></label>
                    <input className="form-input" value={form.nom_commercial} onChange={e => setForm({ ...form, nom_commercial: e.target.value })} required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Région ECF <span style={{ color: 'var(--ecf-error)' }}>*</span></label>
                    <RegionSelect value={form.region_ecf} onChange={v => setForm({ ...form, region_ecf: v })} required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Compte utilisateur <span style={{ color: '#999', fontWeight: 400 }}>(optionnel)</span></label>
                    <select className="form-input" value={form.user_id} onChange={e => setForm({ ...form, user_id: e.target.value })} style={{ margin: 0 }}>
                      <option value="">— Aucun pour l'instant —</option>
                      {allUsers.map(u => <option key={u.id} value={u.id}>{u.prenom} {u.nom} ({u.email})</option>)}
                    </select>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary" onClick={handleCreateAdherent} disabled={saving}>{saving ? 'Création...' : 'Créer'}</button>
                <button className="btn btn-outline" onClick={() => { setShowForm(false); setMsg(null); }}>Annuler</button>
              </div>
            </div>
          </div>
        )}

        {/* Modal édition adhérent */}
        {editAdherent && (
          <div className="modal-overlay">
            <div className="modal-box">
              <div className="modal-header">
                <span className="modal-title">Modifier l'adhérent</span>
                <button onClick={() => { setEditAdherent(null); setMsg(null); }} className="modal-close">✕</button>
              </div>
              <div className="modal-body">
                {msg && <div className={`alert alert-${msg.type}`}>{msg.text}</div>}
                <div className="form-group">
                  <label className="form-label">NPP</label>
                  <input className="form-input" value={editAdherent.npp || ''} onChange={e => setEditAdherent({ ...editAdherent, npp: e.target.value })} required />
                </div>
                <div className="form-group">
                  <label className="form-label">Nom commercial</label>
                  <input className="form-input" value={editAdherent.nom_commercial || ''} onChange={e => setEditAdherent({ ...editAdherent, nom_commercial: e.target.value })} required />
                </div>
                <div className="form-group">
                  <label className="form-label">Région ECF</label>
                  <RegionSelect value={editAdherent.region_ecf} onChange={v => setEditAdherent({ ...editAdherent, region_ecf: v })} required />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary" onClick={handleUpdateAdherent} disabled={saving}>{saving ? 'Enregistrement...' : 'Enregistrer'}</button>
                <button className="btn btn-outline" onClick={() => { setEditAdherent(null); setMsg(null); }}>Annuler</button>
              </div>
            </div>
          </div>
        )}

        {/* Modal transfert structure */}
        {showTransfertForm && (
          <div className="modal-overlay">
            <div className="modal-box">
              <div className="modal-header">
                <span className="modal-title">Transférer la structure</span>
                <button onClick={() => setShowTransfertForm(null)} className="modal-close">✕</button>
              </div>
              <div className="modal-body">
                <div className="alert alert-info" style={{ marginBottom: 16 }}>
                  <strong>{showTransfertForm.raison_sociale}</strong><br />
                  Les bilans historiques resteront consultables par l'adhérent actuel et visibles par le destinataire.
                </div>
                <form onSubmit={handleTransfert}>
                  <div className="form-group">
                    <label className="form-label">Adhérent destinataire <span style={{ color: 'var(--ecf-error)' }}>*</span></label>
                    <select className="form-input" value={transfertForm.adherent_dest_id}
                      onChange={e => setTransfertForm({ ...transfertForm, adherent_dest_id: e.target.value })} required style={{ margin: 0 }}>
                      <option value="">— Sélectionner —</option>
                      {adherents.filter(a => a.id !== selected?.id).map(a => (
                        <option key={a.id} value={a.id}>{a.nom_commercial}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Motif du transfert</label>
                    <input className="form-input" value={transfertForm.motif}
                      onChange={e => setTransfertForm({ ...transfertForm, motif: e.target.value })}
                      placeholder="Ex: Cession, restructuration..." />
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={handleTransfert}>Confirmer le transfert</button>
                <button className="btn btn-outline" onClick={() => setShowTransfertForm(null)}>Annuler</button>
              </div>
            </div>
          </div>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: selected ? '380px 1fr' : '1fr', gap: 20 }}>

          {/* Liste adhérents */}
          <div className="card" style={{ padding: 0 }}>
            <div style={{ padding: '16px 24px', borderBottom: '1px solid var(--ecf-mid-grey)' }}>
              <div className="card-title" style={{ margin: 0 }}>Adhérents ({adherents.length})</div>
            </div>
            {loading ? <div style={{ padding: 24, color: '#999' }}>Chargement...</div> : (
              <div className="table-wrapper">
                <table>
                  <thead><tr><th>Nom commercial</th><th>NPP</th><th>Région</th><th></th></tr></thead>
                  <tbody>
                    {adherents.map(a => (
                      <tr key={a.id} style={{ cursor: 'pointer', background: selected?.id === a.id ? 'rgba(18,68,131,0.04)' : '' }}>
                        <td className="important" onClick={() => selectAdherent(a)}>{a.nom_commercial}</td>
                        <td onClick={() => selectAdherent(a)}>
                          <code style={{ fontSize: '0.78rem', background: '#f4f4f4', padding: '2px 6px' }}>{a.npp}</code>
                        </td>
                        <td style={{ fontSize: '0.75rem' }} onClick={() => selectAdherent(a)}>{a.region_ecf || '—'}</td>
                        <td>
                          <button className="btn btn-outline" style={{ padding: '2px 7px', fontSize: '0.7rem' }}
                            onClick={() => { setEditAdherent({ ...a }); setMsg(null); }}>✎</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* Détail adhérent sélectionné */}
          {selected && (
            <div>
              {/* En-tête */}
              <div className="card" style={{ padding: '16px 20px', marginBottom: 2 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontWeight: 800, fontSize: '1rem', color: 'var(--ecf-blue)' }}>{selected.nom_commercial}</div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--ecf-grey)', marginTop: 2 }}>
                      {selected.region_ecf} &nbsp;|&nbsp; NPP: {selected.npp}
                    </div>
                  </div>
                  <span className={`badge ${selected.actif ? 'badge-success' : 'badge-error'}`}>
                    {selected.actif ? 'Actif' : 'Inactif'}
                  </span>
                </div>
              </div>

              {/* Onglets */}
              <div style={{ display: 'flex', borderBottom: '2px solid var(--ecf-mid-grey)', background: 'white', marginBottom: 0 }}>
                {[['structures', 'Structures'], ['users', 'Utilisateurs rattachés']].map(([key, label]) => (
                  <button key={key} onClick={() => {
                    setActiveTab(key);
                    if (key === 'users') { loadAdherentUsers(selected.id); loadAllUsers(); }
                  }} style={{
                    padding: '10px 20px', border: 'none', cursor: 'pointer', background: 'none',
                    fontFamily: 'var(--font)', fontSize: '0.82rem', fontWeight: 700,
                    color: activeTab === key ? 'var(--ecf-blue)' : 'var(--ecf-grey)',
                    borderBottom: activeTab === key ? '2px solid var(--ecf-blue)' : '2px solid transparent',
                    marginBottom: -2,
                  }}>{label}</button>
                ))}
              </div>

              {/* Onglet Structures */}
              {activeTab === 'structures' && (
                <div className="card" style={{ padding: 0, borderTop: 'none' }}>
                  <div style={{ padding: '12px 20px', borderBottom: '1px solid var(--ecf-mid-grey)', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <button className="btn btn-primary" style={{ padding: '5px 12px', fontSize: '0.72rem' }}
                      onClick={() => { setShowStructForm(true); setEditStructure(null); }}>
                      + Ajouter
                    </button>
                  </div>

                  {showStructForm && (
                    <div style={{ padding: 16, background: 'var(--ecf-light-grey)', borderBottom: '1px solid var(--ecf-mid-grey)' }}>
                      <form onSubmit={handleCreateStructure}>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                          {[['raison_sociale','Raison sociale'],['siren','SIREN'],['siret','SIRET (optionnel)']].map(([k,l]) => (
                            <div className="form-group" key={k}>
                              <label className="form-label" style={{ fontSize: '0.6rem' }}>{l}</label>
                              <input className="form-input" value={structForm[k]}
                                onChange={e => setStructForm({ ...structForm, [k]: e.target.value })} required={k !== 'siret'} />
                            </div>
                          ))}
                          <div className="form-group">
                            <label className="form-label" style={{ fontSize: '0.6rem' }}>Type</label>
                            <select className="form-input" value={structForm.type_structure}
                              onChange={e => setStructForm({ ...structForm, type_structure: e.target.value })}>
                              {['SARL','SAS','EURL','EI','SA','AUTRE'].map(t => <option key={t}>{t}</option>)}
                            </select>
                          </div>
                        </div>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.82rem', marginBottom: 10 }}>
                          <input type="checkbox" checked={structForm.est_holding}
                            onChange={e => setStructForm({ ...structForm, est_holding: e.target.checked })} />
                          Structure holding
                        </label>
                        <div style={{ display: 'flex', gap: 8 }}>
                          <button className="btn btn-primary" type="submit" style={{ padding: '5px 12px', fontSize: '0.75rem' }}>Créer</button>
                          <button className="btn btn-outline" type="button" style={{ padding: '5px 12px', fontSize: '0.75rem' }} onClick={() => setShowStructForm(false)}>Annuler</button>
                        </div>
                      </form>
                    </div>
                  )}

                  {editStructure && (
                    <div style={{ padding: 16, background: '#fffde7', borderBottom: '1px solid var(--ecf-mid-grey)' }}>
                      <form onSubmit={handleUpdateStructure}>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                          {[['raison_sociale','Raison sociale'],['siren','SIREN'],['siret','SIRET']].map(([k,l]) => (
                            <div className="form-group" key={k}>
                              <label className="form-label" style={{ fontSize: '0.6rem' }}>{l}</label>
                              <input className="form-input" value={editStructure[k] || ''}
                                onChange={e => setEditStructure({ ...editStructure, [k]: e.target.value })} required={k !== 'siret'} />
                            </div>
                          ))}
                          <div className="form-group">
                            <label className="form-label" style={{ fontSize: '0.6rem' }}>Type</label>
                            <select className="form-input" value={editStructure.type_structure}
                              onChange={e => setEditStructure({ ...editStructure, type_structure: e.target.value })}>
                              {['SARL','SAS','EURL','EI','SA','AUTRE'].map(t => <option key={t}>{t}</option>)}
                            </select>
                          </div>
                        </div>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.82rem', marginBottom: 10 }}>
                          <input type="checkbox" checked={editStructure.est_holding}
                            onChange={e => setEditStructure({ ...editStructure, est_holding: e.target.checked })} />
                          Structure holding
                        </label>
                        <div style={{ display: 'flex', gap: 8 }}>
                          <button className="btn btn-primary" type="submit" style={{ padding: '5px 12px', fontSize: '0.75rem' }}>Enregistrer</button>
                          <button className="btn btn-outline" type="button" style={{ padding: '5px 12px', fontSize: '0.75rem' }} onClick={() => setEditStructure(null)}>Annuler</button>
                        </div>
                      </form>
                    </div>
                  )}

                  <div className="table-wrapper">
                    <table>
                      <thead><tr><th>Raison sociale</th><th>SIREN</th><th>Type</th><th>Holding</th><th>Actions</th></tr></thead>
                      <tbody>
                        {structures.map(s => (
                          <tr key={s.id} style={{ background: editStructure?.id === s.id ? '#fffde7' : '' }}>
                            <td className="important">
                              {s.raison_sociale}
                              {s.transfert_id && <span className="badge badge-warning" style={{ marginLeft: 8, fontSize: '0.55rem' }}>Transféré</span>}
                            </td>
                            <td><code style={{ fontSize: '0.78rem' }}>{s.siren}</code></td>
                            <td><span className="badge badge-grey">{s.type_structure}</span></td>
                            <td>{s.est_holding ? '✅' : '—'}</td>
                            <td>
                              <div style={{ display: 'flex', gap: 4 }}>
                                <button className="btn btn-outline" style={{ padding: '2px 7px', fontSize: '0.7rem' }}
                                  onClick={() => { setEditStructure({ ...s }); setShowStructForm(false); }}>✎</button>
                                <button className="btn btn-outline" style={{ padding: '2px 7px', fontSize: '0.7rem', color: 'var(--ecf-warning)' }}
                                  onClick={() => { setShowTransfertForm(s); setTransfertForm({ adherent_dest_id: '', motif: '' }); }}>⇄</button>
                              </div>
                            </td>
                          </tr>
                        ))}
                        {structures.length === 0 && <tr><td colSpan={5} style={{ textAlign: 'center', padding: 20, color: '#999' }}>Aucune structure</td></tr>}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Onglet Users */}
              {activeTab === 'users' && (
                <div className="card" style={{ padding: 0, borderTop: 'none' }}>
                  <div style={{ padding: '12px 20px', borderBottom: '1px solid var(--ecf-mid-grey)' }}>
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                      <select className="form-input" style={{ margin: 0, flex: 1, fontSize: '0.82rem' }}
                        onChange={e => e.target.value && handleAddUser(e.target.value)}
                        value="">
                        <option value="">+ Rattacher un utilisateur...</option>
                        {usersNonRattaches.map(u => (
                          <option key={u.id} value={u.id}>{u.prenom} {u.nom} — {u.role}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="table-wrapper">
                    <table>
                      <thead><tr><th>Nom</th><th>Email</th><th>Rôle</th><th>Statut</th><th>Action</th></tr></thead>
                      <tbody>
                        {adherentUsers.map(u => (
                          <tr key={u.user_id}>
                            <td className="important">{u.prenom} {u.nom}</td>
                            <td style={{ fontSize: '0.78rem' }}>{u.email}</td>
                            <td><span className="badge badge-info">{u.role}</span></td>
                            <td><span className={`badge ${u.statut === 'ACTIF' ? 'badge-success' : 'badge-error'}`}>{u.statut}</span></td>
                            <td>
                              <button className="btn btn-outline" style={{ padding: '2px 8px', fontSize: '0.7rem', color: 'var(--ecf-error)' }}
                                onClick={() => handleRemoveUser(u.user_id)}>Détacher</button>
                            </td>
                          </tr>
                        ))}
                        {adherentUsers.length === 0 && <tr><td colSpan={5} style={{ textAlign: 'center', padding: 20, color: '#999' }}>Aucun utilisateur rattaché</td></tr>}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
